import Cookies from 'js-cookie'

export default function (context, inject) {
  inject('cookie', Cookies)
}
